import React, { useEffect, useState } from "react";
import { useAuth } from "oidc-react";
import { navigate } from 'raviger';
import moment from "moment";
import withLayout from "../../hoc/withLayout";
import Spinner from "../../components/Spinner/Spinner";
import { fetchAuthRoles } from "../../lib/FetchAuthRoles";

function Home() {
    const auth = useAuth();
    const [isLoading, setIsLoading] = useState(true);
    const [hasFmRoles, setHasFmRoles] = useState(null);

    useEffect(() => {
        async function fetchData() {
            if (auth.userData) {
                const user = auth.userData;
                const authData = await fetchAuthRoles(user.profile.sub);

                setHasFmRoles(authData.body.fmRoles.length > 0);

                if (authData.body.fmRoles.length === 0) {
                    setIsLoading(true);
                    return;
                }

                // User has roles — store data and proceed
                localStorage.setItem(
                    "authData",
                    JSON.stringify({
                        accessToken: user.access_token,
                        refreshToken: user.refresh_token,
                        expireDate: moment
                            .unix(user.expires_at)
                            .format("YYYY-MM-DDTHH:mm:ss.sssZ"),
                        fullName: user.profile.name,
                        username: user.profile.preferred_username,
                        userId: user.profile.sub,
                        roles: authData.body.fmRoles,
                        permissions: authData.body.fmPermissions,
                    })
                );

                setIsLoading(false);
                navigate("/dashboard");
            }
        }

        fetchData();
    }, [auth.userData]);

    const handleClickLogin = async () => {
        await auth.signOutRedirect();
    };

    if (hasFmRoles === null) {
        return null;
    }

    let content = isLoading ? (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", textAlign: "center", gap: "16px", padding: "16px" }}>
            {hasFmRoles ? (
                <Spinner text="Loading..." />
            ) : (
                <>
                    <p style={{ textTransform: "uppercase", fontWeight: "bold" }}>
                        Invalid username or password.
                    </p>
                    <button
                        style={{
                            padding: "10px 20px",
                            backgroundColor: "#3498db",
                            color: "white",
                            border: "none",
                            borderRadius: "8px",
                            cursor: "pointer",
                            fontSize: "14px",
                            fontWeight: "bold"
                        }}
                        onClick={handleClickLogin}
                    >
                        RETURN TO LOGIN
                    </button>
                </>
            )}
        </div>
    ) : null;

    return content;
}

export default withLayout(Home);
